import { Routes } from '@angular/router';
import { AppLayout } from './layout/component/app.layout.component';
import { DashboardComponent } from './modules/PRINCIPAL/pages/dashboard/dashboard.component';
import { PerfilComponent } from './modules/PRINCIPAL/pages/perfil/perfil.component';
import { TipoCargaComponent } from './modules/MANTENEDORES/pages/tipo-carga/tipo-carga.component';
import { TipoCombustionComponent } from './modules/MANTENEDORES/pages/tipo-combustion/tipo-combustion.component';
import { TiposTrabajoComponent } from './modules/MANTENEDORES/pages/tipos-trabajo/tipos-trabajo.component';
import { TiposVehiculoComponent } from './modules/MANTENEDORES/pages/tipos-vehiculo/tipos-vehiculo.component';
import { TiposTraccionComponent } from './modules/MANTENEDORES/pages/tipos-traccion/tipos-traccion.component';
import { TiposUsuarioComponent } from './modules/SEGURIDAD/pages/tipos-usuario/tipos-usuario.component';
import { UsuariosIntranetComponent } from './modules/SEGURIDAD/pages/usuarios/usuarios.component';
import { RolesComponent } from './modules/SEGURIDAD/pages/roles/roles.component';
import { PermisosComponent } from './modules/SEGURIDAD/pages/permisos/permisos.component';
import { ReporteSolicitudesComponent } from './modules/REPORTES/pages/solicitudes/solicitudes.component';
import { ReporteValoracionesComponent } from './modules/REPORTES/pages/valoraciones/valoraciones.component';
import { ReporteUsuariosComponent } from './modules/REPORTES/pages/usuarios/usuarios.component';
import { ReporteVehiculosComponent } from './modules/REPORTES/pages/vehiculos/vehiculos.component';
import { ReporteMonitoreoComponent } from './modules/REPORTES/pages/monitoreo/monitoreo.component';
import { AuthGuard } from './core/guards/auth.guard';
import { Notfound } from './core/components/notfound/notfound.component';
import { RutasGuard } from './core/guards/permisoss.guard';
export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        children: [
            { path: '', component: DashboardComponent, title: 'Dashboard'},
            { path: 'perfil', component: PerfilComponent, title: 'Perfil' },
            { path: 'mantenedores/tipo-carga', component: TipoCargaComponent, title: 'Tipo de carga' },
            { path: 'mantenedores/tipo-combustion', component: TipoCombustionComponent, title: 'Tipo de combustión' },
            { path: 'mantenedores/tipos-trabajo', component: TiposTrabajoComponent, title: 'Tipos de trabajo' },
            { path: 'mantenedores/tipos-vehiculo', component: TiposVehiculoComponent, title: 'Tipos de vehículo' },
            { path: 'mantenedores/tipos-traccion', component: TiposTraccionComponent, title: 'Tipos de tracción' },
            { path: 'mantenedores/flota', redirectTo: 'mantenedores/tipos-vehiculo', pathMatch: 'full' },
            { path: 'seguridad/tipos-usuario', component: TiposUsuarioComponent, title: 'Tipos de usuario' },
            { path: 'seguridad/usuarios', component: UsuariosIntranetComponent, title: 'Usuarios' },
            { path: 'seguridad/roles', component: RolesComponent, title: 'Roles' },
            { path: 'seguridad/permisos', component: PermisosComponent, title: 'Permisos' },
            { path: 'reportes/solicitudes', component: ReporteSolicitudesComponent, title: 'Solicitudes' },
            { path: 'reportes/valoraciones', component: ReporteValoracionesComponent, title: 'Valoraciones' },
            { path: 'reportes/usuarios', component: ReporteUsuariosComponent, title: 'Usuarios del aplicativo' },
            { path: 'reportes/vehiculos', component: ReporteVehiculosComponent, title: 'Vehículos' },
            { path: 'reportes/logsapp', component: ReporteMonitoreoComponent, title: 'Logs' },
            //{ path: 'fi', loadChildren: () => import('./modules/FI/fi.routes') }
        ],
        canActivate: [AuthGuard,RutasGuard]
    },
    { path: 'notfound', component: Notfound },
    { path: 'auth', loadChildren: () => import('./auth/auth.routes') },
    { path: '**', redirectTo: '/notfound' }
];
